import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import Avatar from "@material-ui/core/Avatar";
import Grey from "@material-ui/core/colors/grey";
import LightGreen from "@material-ui/core/colors/lightGreen";
import Orange from "@material-ui/core/colors/orange";
import Icon from "@material-ui/core/Icon";
import CardMedia from "@material-ui/core/CardMedia";
import AnswerBox from "./answerBox";

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    [theme.breakpoints.down("sm")]: {
      margin: "4px"
    }
  },
  title: {
    marginBottom: theme.spacing.unit
  },
  avatar: {
    width: "24px",
    height: "24px",
    marginRight: theme.spacing.unit
  },
  image: {
    height: 0,
    paddingTop: "100%",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "56.25%"
    }
  },
  mb1: {
    marginBottom: theme.spacing.unit
  },
  ml1: {
    marginLeft: theme.spacing.unit
  },
  footerBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    fontSize: '14px'
  },
  avatarBox: {
    display: 'flex',
    marginRight: theme.spacing.unit,
    alignItems: 'center'
  },
  metaBox: {
    marginRight: theme.spacing.unit,
    color: Grey[400]
  },
  goodBox: {
    color: Grey[400],
    display: 'flex',
    alignItems: 'center'
  },
  typeBox: {
    marginLeft: 'auto',
    border: '2px solid',
    paddingTop: theme.spacing.unit / 5,
    paddingBottom: theme.spacing.unit / 5,
    paddingLeft: theme.spacing.unit / 2,
    paddingRight: theme.spacing.unit /2
  }
});

function ResultItem(props) {
  const { classes, post } = props;
  let typeColor = post.type === 'Q' ? Orange[500] : LightGreen[700];
  let contentWidth = post.image ? 10 : 12;
  return (
    <ListItem alignItems="flex-start" divider>
        <div className={classes.mb1}>
            <Typography variant="h6" className={classes.title}>
                <Link href={post.url} target="_blank">
                    {post.title}
                </Link>
            </Typography>

            <Grid>
                <Grid container direction="row" spacing={16}>
                    { post.image &&
                    <Grid item xs={12} sm={2}>
                        <Link href={post.url} target="_blank">
                        <div className={classes.mb1}>
                            <CardMedia image={post.image} className={classes.image} />
                        </div>
                        </Link>
                    </Grid>
                    }
                    <Grid item xs={12} sm={contentWidth}>
                        <div className={classes.mb1}>
                        <Typography variant="body1">
                            {post.content}
                        </Typography>
                        </div>

                        <div className={classes.footerBox}>
                            <Link href={post.userUrl} target="_blank">
                                <div className={classes.avatarBox}>
                                <Avatar
                                    alt={post.handle}
                                    src={post.avatar}
                                    className={classes.avatar}
                                />
                                <span>{post.handle}</span>
                                </div>
                            </Link>
                            <div className={classes.metaBox}>
                                投稿日：{post.created} , 閲覧 {post.views}
                            </div>
                            <div className={classes.goodBox}>
                                <Icon style={{ fontSize: 20 }}>thumb_up</Icon>
                                <div className={classes.ml1}>{post.voted}</div>
                            </div>
                            <div className={classes.typeBox} style={{ color: typeColor}}>
                                {post.typeLabel}
                            </div>
                        </div>
                        {post.answers.acount > 0 ? <AnswerBox answers={post.answers} /> : null}
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </ListItem>
  );
}

ResultItem.propTypes = {
  classes: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired
};
export default withStyles(styles)(ResultItem);